let cached: string[] | null = null;

import { apiFetch } from '../api';

export async function loadPermissions(force = false): Promise<string[]> {
  if (cached && !force) return cached;
  try {
    const data: string[] = await apiFetch('/auth/permissions');
    cached = Array.isArray(data) ? data : [];
    return cached;
  } catch (e) {
    cached = [];
    return [];
  }
}

export function setCachedPermissions(perms: string[]) {
  cached = perms;
}

export function clearPermissionCache() {
  cached = null;
}

export function hasPermissionSync(code: string) {
  try {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');
    // quick heuristic: if user has 'SuperAdmin' role, allow everything
    if (roles.includes('SuperAdmin')) return true;
    if (!cached) return false;
    return cached.includes(code);
  } catch (e) {
    return false;
  }
}

export async function hasPermission(code: string) {
  const perms = await loadPermissions();
  return perms.includes(code) || JSON.parse(localStorage.getItem('roles') || '[]').includes('SuperAdmin');
}
